import { render } from "./Contact.vue?vue&type=template&id=121ccdb6&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=121ccdb6&scoped=true&lang=css"

import exportComponent from "/Users/user/Desktop/personal_projects/music_quiz/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-121ccdb6"]])

export default __exports__